var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.state,"color":_vm.colorMessage,"timeout":_vm.data && _vm.data.duration ? _vm.data.duration : 1000}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.iconMessage))]),_c('span',[_vm._v(_vm._s(_vm.data && _vm.data.message ? _vm.data.message : 'NA'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }